/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MyDisciplineDTO,
    MyDisciplineDTOFromJSON,
    MyDisciplineDTOFromJSONTyped,
    MyDisciplineDTOToJSON,
} from './MyDisciplineDTO';

/**
 * 
 * @export
 * @interface MyDisciplineDTOPagedResponse
 */
export interface MyDisciplineDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof MyDisciplineDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MyDisciplineDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof MyDisciplineDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<MyDisciplineDTO>}
     * @memberof MyDisciplineDTOPagedResponse
     */
    data?: Array<MyDisciplineDTO> | null;
}

export function MyDisciplineDTOPagedResponseFromJSON(json: any): MyDisciplineDTOPagedResponse {
    return MyDisciplineDTOPagedResponseFromJSONTyped(json, false);
}

export function MyDisciplineDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDisciplineDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(MyDisciplineDTOFromJSON)),
    };
}

export function MyDisciplineDTOPagedResponseToJSON(value?: MyDisciplineDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(MyDisciplineDTOToJSON)),
    };
}

